module.exports = __webpack_public_path__ + "pc/img/swiper_logo_popeyes.99e99ad6.png";